import React from 'react';
import { withRouter } from 'react-router-dom';
import { Layout, Dropdown, Menu, Badge, Tooltip, Select, Button, Modal, Image, Spin } from 'antd';
import {
    UserOutlined,
    PushpinOutlined,
    InfoCircleOutlined,
    MailOutlined,
    BellOutlined
} from '@ant-design/icons';
import MobileMenu from "../MobileMenu/MobileMenu";
import firebase from "../../firebase";
import { db } from "../../App";

const { Header } = Layout;

class MobileNavbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            organization: {},
            company: {},
            seller: {},
            seller_company: {},
            organizationUnread: {},
            unread: 0,
            unreadNotShipped: 0,
            sellerOrganizations: [],
            buyerOrganizations: [],
            sellerOrg: null,
            selectCountOrgs: [],

            searchOrg: '',
            searchOrg1: '',
            searchOrgBuyer: '',
            searchOrgSeller: '',
            searchOrgCustomer: '',
            filteredOrg: [],
            filteredOrg1: [],
            filteredOrgBuyer: [],
            filteredOrgSeller: [],
            filteredOrgCustomer: [],

            // Notification state (matching P4Header1)
            showNotif: false,
            showNotification: false,
            notification: {},
            notifications: [],
            selectedNotification: null,
            showListNotif: false
        };
    }

    sumObjectsByKey = (...objs) => {
        return objs.reduce((a, b) => {
            if (b) {
                for (let k in b) {
                    if (b.hasOwnProperty(k))
                        a[k] = (a[k] || 0) + b[k];
                }
            }
            return a;
        }, {});
    }

    getTopOrgs = async () => {
        if (!this.props.user || !this.props.user.id) return;
        let querySnapshot = await this.props.db
            .collection('org_select')
            .doc(this.props.user.id)
            .collection('org')
            .orderBy('pinned', 'desc')
            .orderBy('selectCount', 'desc')
            .get();

        let selectCountOrgs = querySnapshot.docs.map(org => {
            return { id: org.id, ...org.data() }
        });

        this.setState({ selectCountOrgs });
    }

    componentDidMount() {
        if (this.props.userOrg) {
            this.organizationCheck(this.props.userOrg?.id, true);
        }
        this.getTopOrgs();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.notificationLoad(nextProps.userOrg, nextProps.org);
        this.getTopOrgs();
        if ((nextProps.orgSeller && nextProps.orgSeller.id) !== this.state.sellerOrg) {
            this.setState({
                sellerOrg: nextProps.orgSeller && nextProps.orgSeller.id
            }, () => {
                if (nextProps.orgSeller) this.selectSellerOrganization(nextProps.orgSeller, true);
            });
        }

        if (nextProps.userOrg && (!this.props.userOrg || this.props.userOrg.id !== nextProps.userOrg.id)) {
            this.organizationCheck(nextProps.userOrg.id, true);
        } else if (!nextProps.userOrg && this.props.userOrg) {
            this.setState({ organization: null });
        }

        this.setState({
            organizationUnread: this.sumObjectsByKey(
                nextProps.unreadOrderWithOrg || {},
                nextProps.unreadBillWithOrg || {},
                nextProps.unreadDeliveryNotesWithOrg || {},
                nextProps.unreadEstimates2WithOrg || {},
                nextProps.unreadEstimatesWithOrg || {},
                nextProps.unreadReportWithOrg || {},
                nextProps.unreadOCHWithOrg || {}
            ),
            unread: (
                (nextProps.unreadOrder || 0) +
                (nextProps.unreadBill || 0) +
                (nextProps.unreadDeliveryNotes || 0) +
                (nextProps.unreadEstimates2 || 0) +
                (nextProps.unreadEstimates || 0) +
                (nextProps.unreadReport || 0) +
                (nextProps.unreadOCH || 0)
            ),
            unreadNotShipped: nextProps.notShippedOrder || 0
        });
    }

    selectSellerOrganization = (seller, initial) => {
        this.setState({
            buyerOrganizations: seller.buyers || []
        });
        if (this.props.orgSelectSeller) {
            this.props.orgSelectSeller(seller.id, (seller.company_name || (seller.name2 || '')) + ' ' + (seller.name2 ? '' : seller.name), initial);
        }
    }

    // selectUserOrg — P4Header1 pattern ашиглав
    selectUserOrg = (value, option) => {
        this.organizationCheck(option.id, false);
    }

    organizationCheck = (orgId, init) => {
        if (orgId) {
            let organizationRef = this.props.db.collection('organizations').doc(orgId);
            organizationRef.get()
                .then(doc => {
                    if (!doc.exists) {
                        console.log('No such organization document!');
                        this.setState({ organization: null });
                        this.companyCheck(init);
                    } else {
                        if (doc.data().active) {
                            let org = doc.data();
                            org.id = doc.id;
                            this.setState({ organization: org }, () => {
                                this.companyCheck(init);
                            });
                        }
                    }
                })
                .catch(err => {
                    console.log('Error getting organization document', orgId, err);
                });
        } else if (this.props.user && this.props.user.admin) {
            this.adminUserList()
                .then((snapshot) => {
                    if (snapshot.length > 0) {
                        let organizations = [];
                        snapshot.forEach((doc) => {
                            let data = doc.data();
                            data.id = doc.id;
                            organizations.push(data);
                        });
                        this.setState({
                            sellerOrganizations: organizations,
                            buyerOrganizations: []
                        });
                    }
                });
        }
    }

    adminUserList = async () => {
        const seller = this.props.db.collection('organizations').where('reseller', '==', true).get();
        const maker = this.props.db.collection('organizations').where('maker', '==', true).get();

        const [sellerSnapshot, makerSnapshot] = await Promise.all([seller, maker]);

        const sellerArray = sellerSnapshot.docs || [];
        const makerArray = makerSnapshot.docs || [];

        return sellerArray.concat(makerArray);
    }

    companyCheck = (init) => {
        if (this.state.organization && this.state.organization.company) {
            let companyRef = this.props.db.collection('company').doc(this.state.organization.company);
            companyRef.get()
                .then(doc => {
                    if (doc.exists && doc.data().active) {
                        let company = doc.data();
                        company.id = doc.id;
                        this.setState({ company: company });
                        let org = this.state.organization;
                        org.display_name = company.name + ' ' + org.name;
                        if (this.props.setupOrgAndCompany) this.props.setupOrgAndCompany(org, init);
                    } else {
                        if (this.props.setupOrgAndCompany) this.props.setupOrgAndCompany(null, init);
                    }
                })
                .catch(err => console.log('Error getting company document', err));
        } else {
            if (this.props.setupOrgAndCompany) this.props.setupOrgAndCompany(null, init);
        }
    }

    sellerCheck = (org) => {
        if (!org) org = this.state.organization;
        if (org && org.seller) {
            let sellerRef = this.props.db.collection('organizations').doc(org.seller);
            sellerRef.get()
                .then(doc => {
                    if (doc.exists && doc.data().active) {
                        let seller = doc.data();
                        seller.id = doc.id;
                        this.setState({ seller: seller }, () => {
                            this.seller_companyCheck(org, seller);
                        });
                    }
                });
        }
    }

    seller_companyCheck = (org, seller) => {
        if (!org) org = this.state.organization;
        if (!seller) seller = this.state.seller;
        if (org && seller && seller.company) {
            let companyRef = this.props.db.collection('company').doc(seller.company);
            companyRef.get()
                .then(doc => {
                    if (doc.exists && doc.data().active) {
                        let seller_company = doc.data();
                        this.setState({ seller_company: seller_company });
                        if (this.props.orgSelectData) this.props.orgSelectData(seller.id, seller_company.name + ' ' + seller.name);
                    }
                });
        }
    }

    componentWillUnmount() {
        if (this.notificationUnsubscribe) {
            this.notificationUnsubscribe();
        }
    }

    // Notification load — P4Header1 pattern ашиглав
    notificationLoad = async (userOrg, org) => {
        if (!userOrg) {
            return;
        }

        if (this.notificationUnsubscribe) {
            this.notificationUnsubscribe();
        }

        this.notificationUnsubscribe = db.collection("notification")
            .where("isActive", "==", true)
            .onSnapshot((snapshot) => {
                if (!snapshot || snapshot.empty) {
                    this.setState({ notifications: [], showNotification: false });
                    return;
                }

                const now = new Date();
                const matched = [];

                snapshot.forEach((doc) => {
                    const data = doc.data();
                    data.id = doc.id;

                    const start = data.displayStart ? data.displayStart.toDate() : null;
                    const end = data.displayEnd ? data.displayEnd.toDate() : null;

                    if (start && now < start) return;
                    if (end) {
                        const endOfDay = new Date(end);
                        endOfDay.setHours(23, 59, 59, 999);
                        if (now > endOfDay) return;
                    }

                    if (data.targetRoles && data.targetRoles.length > 0) {
                        let roleMatch = false;

                        // Check Maker role
                        if (data.targetRoles.includes("maker") && userOrg.maker) {
                            if (data.targetOrgsMaker && data.targetOrgsMaker.length > 0) {
                                if (data.targetOrgsMaker.includes(userOrg.id) || (org && data.targetOrgsMaker.includes(org.id))) {
                                    roleMatch = true;
                                }
                            } else if (data.targetOrgsMaker) {
                                // targetOrgsMaker exists but is empty -> all makers
                                roleMatch = true;
                            } else {
                                // Legacy fallback: check if org is in targetOrgs
                                if (!data.targetOrgs || data.targetOrgs.length === 0 || data.targetOrgs.includes(userOrg.id) || (org && data.targetOrgs.includes(org.id))) {
                                    roleMatch = true;
                                }
                            }
                        }

                        // Check Seller role
                        if (data.targetRoles.includes("reseller") && userOrg.reseller) {
                            if (data.targetOrgsReseller && data.targetOrgsReseller.length > 0) {
                                if (data.targetOrgsReseller.includes(userOrg.id) || (org && data.targetOrgsReseller.includes(org.id))) {
                                    roleMatch = true;
                                }
                            } else if (data.targetOrgsReseller) {
                                if (data.baseOrgSellers && data.baseOrgSellers.length > 0) {
                                    if (data.baseOrgSellers.includes(userOrg.id) || (org && data.baseOrgSellers.includes(org.id))) {
                                        roleMatch = true;
                                    }
                                } else if (data.baseOrgId) {
                                    if (userOrg.id === data.baseOrgId || (org && org.id === data.baseOrgId)) {
                                        roleMatch = true;
                                    }
                                } else {
                                    roleMatch = true;
                                }
                            } else {
                                if (data.targetOrgs && data.targetOrgs.length > 0 && (data.targetOrgs.includes(userOrg.id) || (org && data.targetOrgs.includes(org.id)))) {
                                    roleMatch = true;
                                }
                            }
                        }

                        // Check Buyer role
                        if (data.targetRoles.includes("buyer") && userOrg.buyer) {
                            if (data.targetOrgsBuyer && data.targetOrgsBuyer.length > 0) {
                                if (data.targetOrgsBuyer.includes(userOrg.id) || (org && data.targetOrgsBuyer.includes(org.id))) {
                                    roleMatch = true;
                                }
                            } else if (data.targetOrgsBuyer) {
                                if (data.baseOrgBuyers && data.baseOrgBuyers.length > 0) {
                                    if (data.baseOrgBuyers.includes(userOrg.id) || (org && data.baseOrgBuyers.includes(org.id))) {
                                        roleMatch = true;
                                    }
                                } else if (data.baseOrgId) {
                                    if (userOrg.id === data.baseOrgId || (org && org.id === data.baseOrgId)) {
                                        roleMatch = true;
                                    }
                                } else {
                                    roleMatch = true;
                                }
                            } else {
                                if (data.targetOrgs && data.targetOrgs.length > 0 && (data.targetOrgs.includes(userOrg.id) || (org && data.targetOrgs.includes(org.id)))) {
                                    roleMatch = true;
                                }
                            }
                        }

                        if (!roleMatch) return;
                    } else {
                        let isBuyer = false;
                        let isSeller = false;
                        if ((userOrg.buyer && org && org.reseller) || (userOrg.reseller && org && org.maker)) {
                            isBuyer = true;
                        }
                        if ((userOrg.reseller && org && org.buyer) || (userOrg.maker && org && org.reseller)) {
                            isSeller = true;
                        }
                        const targetUser =
                            data.userType === 'all' ||
                            (data.userType === 'buyer' && isBuyer) ||
                            (data.userType === 'seller' && isSeller);
                        if (!targetUser) return;

                        if (data.targetOrgs && data.targetOrgs.length > 0) {
                            const orgMatch = data.targetOrgs.includes(userOrg.id) || (org && data.targetOrgs.includes(org.id));
                            if (!orgMatch) {
                                return;
                            }
                        }
                    }

                    matched.push(data);
                });

                matched.sort((a, b) => {
                    const dateA = a.createdAt ? (a.createdAt.toDate ? a.createdAt.toDate() : new Date(a.createdAt)) : 0;
                    const dateB = b.createdAt ? (b.createdAt.toDate ? b.createdAt.toDate() : new Date(b.createdAt)) : 0;
                    return dateB - dateA;
                });

                if (matched.length > 0) {
                    this.setState({ notifications: matched, showNotification: true });
                } else {
                    this.setState({ notifications: [], showNotification: false });
                }
            });
    }

    selectOrg = async (value, option) => {
        let pinOrgRef = this.props.db.collection('org_select').doc(this.props.user.id).collection('org').doc(option.id);
        let pinOrgSnapshot = await pinOrgRef.get();

        if (!pinOrgSnapshot.exists) {
            await pinOrgRef.set({ selectCount: firebase.firestore.FieldValue.increment(1), pinned: false }, { merge: true });
        } else {
            await pinOrgRef.set({ selectCount: firebase.firestore.FieldValue.increment(1) }, { merge: true });
        }

        if (this.props.orgSelect) this.props.orgSelect(option.id, option.name);
    }

    pinOrg = async (orgId, pinned) => {
        let pinOrgRef = this.props.db.collection('org_select').doc(this.props.user.id).collection('org').doc(orgId);
        let pinOrgSnapshot = await pinOrgRef.get();

        if (!pinOrgSnapshot.exists) {
            await pinOrgRef.set({ selectCount: firebase.firestore.FieldValue.increment(1), pinned: true }, { merge: true });
        } else {
            await pinOrgRef.set({ selectCount: firebase.firestore.FieldValue.increment(1), pinned: !pinned }, { merge: true });
        }

        await this.getTopOrgs();
    }

    handleMenuClick = (e) => {
        switch (e.key) {
            case '11':
                this.props.history.push('/support');
                break;
            case '1':
                this.props.history.push('/emailsettings');
                break;
            case '2':
                this.props.logout();
                break;
            default:
                break;
        }
    }

    render() {
        const { user, org, orgSeller, userOrg } = this.props;

        let orgList = [];
        let orgList2 = [];
        let orgListUser = [];
        let sellerOrganizations = this.state.sellerOrganizations;
        if (this.state.searchOrg) {
            sellerOrganizations = this.state.filteredOrg;
        }

        let buyerOrganizations = this.state.buyerOrganizations;
        if (this.state.searchOrg1) {
            buyerOrganizations = this.state.filteredOrg1;
        }

        let buyersOrganizations = this.state.organization && this.state.organization.buyers;
        if (this.state.searchOrgBuyer || this.state.searchOrgBuyerSeller) {
            buyersOrganizations = this.state.filteredOrgBuyer;
        }

        let sellersOrganizations = this.state.organization && this.state.organization.sellers;
        if (this.state.searchOrgSeller || this.state.searchOrgBuyerSeller) {
            sellersOrganizations = this.state.filteredOrgSeller;
        }

        let resellerOrganizations = this.state.organization && this.state.organization.resellers;
        if (this.state.searchOrgSeller || this.state.searchOrgBuyerSeller) {
            resellerOrganizations = this.state.filteredOrgReseller;
        }

        let customersOrganizations = this.state.organization && this.state.organization.customers;
        if (this.state.searchOrgCustomer) {
            customersOrganizations = this.state.filteredOrgCustomer;
        }

        let addonBeforeName = '';

        if (this.state.organization && this.state.organization.administrator) {
            customersOrganizations && customersOrganizations.map((customers, i) => {
                orgList.push({
                    key: customers.organization ? `customer_${customers.organization}` : `customer_${i}`,
                    id: customers.organization,
                    value: `${customers.name}`,
                    label: <span style={{ display: 'flex', gap: 5 }}>
                        <Tooltip title={'未読'}><Badge color={'#52c41a'} title={''} count={this.state.organizationUnread[customers.organization] || 0} showZero={false} /></Tooltip>
                        {customers.name}
                        <Tooltip title={'未出荷'}><Badge color={'#f5222d'} title={''} count={(this.props.notShippedOrderWithOrg || {})[customers.organization] || 0} showZero={false} /></Tooltip>
                        <Tooltip title={'正常更新中'}><Badge color={'#4185F4'} title={''} overflowCount={999} count={(this.props.sdsNormalCountWithOrg || {})[customers.organization] || 0} showZero={false} /></Tooltip>
                        <Tooltip title={'チェック更新期限日まで1週間以内'}><Badge color={'#FEBE48'} title={''} overflowCount={999} count={(this.props.sdsWarningCountWithOrg || {})[customers.organization] || 0} showZero={false} /></Tooltip>
                        <Tooltip title={'チェック更新日期限切れ'}><Badge color={'#8000FF'} title={''} overflowCount={999} count={(this.props.sdsAlertCountWithOrg || {})[customers.organization] || 0} showZero={false} /></Tooltip>
                        <Tooltip title={'キャンセル承認待'}><Badge style={{ borderRadius: 0 }} color={'#ff63e0'} title={''} overflowCount={999} count={(this.props.cancelOrderWithOrg || {})[customers.organization] || 0} showZero={false} /></Tooltip>
                        <Tooltip title={'返品承認待'}><Badge style={{ borderRadius: 0 }} color={'#00C2FF'} title={''} overflowCount={999} count={(this.props.returnOrderWithOrg || {})[customers.organization] || 0} showZero={false} /></Tooltip>
                    </span>,
                    name: customers.name,
                    organizationUnread: this.state.organizationUnread[customers.organization] || 0,
                    notShippedOrder: (this.props.sdsNormalCountWithOrg || {})[customers.organization] || 0,
                    sdsNormal: (this.props.sdsNormalCountWithOrg || {})[customers.organization] || 0,
                    sdsWarning: (this.props.sdsWarningCountWithOrg || {})[customers.organization] || 0,
                    sdsAlert: (this.props.sdsAlertCountWithOrg || {})[customers.organization] || 0,
                    sdsWait: (this.props.sdsWaitingCountWithOrg || {})[customers.organization] || 0
                });
            });
        }

        if (this.state.organization && this.state.organization.buyer) {
            if (resellerOrganizations) {
                resellerOrganizations.map((seller, i) => {
                    orgList.push({
                        key: seller.organization ? `reseller_${seller.organization}` : `reseller_${i}`,
                        id: seller.organization,
                        value: `[仕入先] ${seller.name}`,
                        label: <span style={{
                            display: 'flex', gap: 5
                        }}>
                            {this.state.organizationUnread[seller.organization] > 0 &&
                                <Tooltip title={'未読'}><Badge color={'#52c41a'} overflowCount={999} title={''}
                                    count={this.state.organizationUnread[seller.organization] || 0} showZero={false} /></Tooltip>}
                            [仕入先] {seller.name}
                            {(this.props.notShippedOrderWithOrg || {})[seller.organization] > 0 &&
                                <Tooltip title={'未出荷'}><Badge color={'#f5222d'} overflowCount={999} title={''}
                                    count={(this.props.notShippedOrderWithOrg || {})[seller.organization] || 0}
                                    showZero={false} /></Tooltip>}
                            {(this.props.sdsNormalCountWithOrg || {})[seller.organization] > 0 &&
                                <Tooltip title={'正常更新中'}><Badge color={'#4185F4'} overflowCount={999} title={''}
                                    count={(this.props.sdsNormalCountWithOrg || {})[seller.organization] || 0}
                                    showZero={false} /></Tooltip>}
                            {(this.props.sdsWarningCountWithOrg || {})[seller.organization] > 0 &&
                                <Tooltip title={'チェック更新期限日まで1週間以内'}><Badge color={'#FEBE48'} overflowCount={999} title={''}
                                    count={(this.props.sdsWarningCountWithOrg || {})[seller.organization] || 0}
                                    showZero={false} /></Tooltip>}
                            {(this.props.sdsAlertCountWithOrg || {})[seller.organization] > 0 &&
                                <Tooltip title={'チェック更新日期限切れ'}><Badge color={'#8000FF'} overflowCount={999} title={''}
                                    count={(this.props.sdsAlertCountWithOrg || {})[seller.organization] || 0}
                                    showZero={false} /></Tooltip>}
                            {(this.props.sdsWaitingCountWithOrg || {})[seller.organization] > 0 &&
                                <Tooltip title={'SDS管理依頼中'}><Badge color={'#58C7C4'} overflowCount={999} title={''}
                                    count={(this.props.sdsWaitingCountWithOrg || {})[seller.organization] || 0}
                                    showZero={false} /></Tooltip>}
                            {(this.props.cancelOrderWithOrg || {})[seller.organization] > 0 && <Tooltip title={'キャンセル承認待'}><Badge style={{ borderRadius: 0 }} color={'#ff63e0'} title={''} overflowCount={999} count={(this.props.cancelOrderWithOrg || {})[seller.organization] || 0} showZero={false} /></Tooltip>}
                            {(this.props.returnOrderWithOrg || {})[seller.organization] > 0 && <Tooltip title={'返品承認待'}><Badge style={{ borderRadius: 0 }} color={'#00C2FF'} title={''} overflowCount={999} count={(this.props.returnOrderWithOrg || {})[seller.organization] || 0} showZero={false} /></Tooltip>}
                        </span>,
                        name: seller.name,
                        organizationUnread: this.state.organizationUnread[seller.organization] || 0,
                        notShippedOrder: (this.props.sdsNormalCountWithOrg || {})[seller.organization] || 0,
                        sdsNormal: (this.props.sdsNormalCountWithOrg || {})[seller.organization] || 0,
                        sdsWarning: (this.props.sdsWarningCountWithOrg || {})[seller.organization] || 0,
                        sdsAlert: (this.props.sdsAlertCountWithOrg || {})[seller.organization] || 0,
                        sdsWait: (this.props.sdsWaitingCountWithOrg || {})[seller.organization] || 0
                    })
                })
            }
        }

        if (this.state.organization && this.state.organization.reseller) {
            if ((this.props.org && this.props.org.display_name && !this.props.location.pathname.startsWith('/measurement'))) {
                addonBeforeName = this.props.org.maker ? '[仕入モード]　' : (this.props.org.buyer ? '[販売モード]' : '');
            } else if (this.props.location.pathname.startsWith('/measurement')) {
                addonBeforeName = '[測定データモード]';
            }
            if (buyersOrganizations) {
                buyersOrganizations.map((buyers, i) => {
                    orgList.push({
                        key: buyers.organization ? `buyer_${buyers.organization}` : `buyer_${i}`,
                        id: buyers.organization,
                        value: `[売先] ${buyers.name}`,
                        label: <span style={{ display: 'flex', gap: 5, fontSize: '14px' }}>
                            {this.state.organizationUnread[buyers.organization] > 0 && <Tooltip title={'未読'}><Badge color={'#52c41a'} overflowCount={999} title={''} count={this.state.organizationUnread[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            [売先] {buyers.name}
                            {(this.props.notShippedOrderWithOrg || {})[buyers.organization] > 0 && <Tooltip title={'未出荷'}><Badge color={'#f5222d'} overflowCount={999} title={''} count={(this.props.notShippedOrderWithOrg || {})[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            {(this.props.cancelOrderWithOrg || {})[buyers.organization] > 0 && <Tooltip title={'キャンセル承認待'}><Badge style={{ borderRadius: 0 }} color={'#ff63e0'} title={''} overflowCount={999} count={(this.props.cancelOrderWithOrg || {})[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            {(this.props.returnOrderWithOrg || {})[buyers.organization] > 0 && <Tooltip title={'返品承認待'}><Badge style={{ borderRadius: 0 }} color={'#00C2FF'} title={''} overflowCount={999} count={(this.props.returnOrderWithOrg || {})[buyers.organization] || 0} showZero={false} /></Tooltip>}
                        </span>,
                        name: buyers.name,
                        organizationUnread: this.state.organizationUnread[buyers.organization] || 0,
                        notShippedOrder: (this.props.sdsNormalCountWithOrg || {})[buyers.organization] || 0,
                        sdsNormal: (this.props.sdsNormalCountWithOrg || {})[buyers.organization] || 0,
                        sdsWarning: (this.props.sdsWarningCountWithOrg || {})[buyers.organization] || 0,
                        sdsAlert: (this.props.sdsAlertCountWithOrg || {})[buyers.organization] || 0,
                        sdsWait: (this.props.sdsWaitingCountWithOrg || {})[buyers.organization] || 0
                    });
                });
            }

            if (sellersOrganizations) {
                sellersOrganizations.map((seller, i) => {
                    orgList.push({
                        key: seller.organization ? `seller_${seller.organization}` : `seller_${i}`,
                        id: seller.organization,
                        value: `[仕入先] ${seller.name}`,
                        label: <span style={{ display: 'flex', gap: 5 }}>
                            {this.state.organizationUnread[seller.organization] > 0 && <Tooltip title={'未読'}><Badge color={'#52c41a'} overflowCount={999} title={''} count={this.state.organizationUnread[seller.organization] || 0} showZero={false} /></Tooltip>}
                            [仕入先] {seller.name}
                            {(this.props.notShippedOrderWithOrg || {})[seller.organization] > 0 && <Tooltip title={'未出荷'}><Badge color={'#f5222d'} overflowCount={999} title={''} count={(this.props.notShippedOrderWithOrg || {})[seller.organization] || 0} showZero={false} /></Tooltip>}
                            {(this.props.cancelOrderWithOrg || {})[seller.organization] > 0 && <Tooltip title={'キャンセル承認待'}><Badge style={{ borderRadius: 0 }} color={'#ff63e0'} title={''} overflowCount={999} count={(this.props.cancelOrderWithOrg || {})[seller.organization] || 0} showZero={false} /></Tooltip>}
                            {(this.props.returnOrderWithOrg || {})[seller.organization] > 0 && <Tooltip title={'返品承認待'}><Badge style={{ borderRadius: 0 }} color={'#00C2FF'} title={''} overflowCount={999} count={(this.props.returnOrderWithOrg || {})[seller.organization] || 0} showZero={false} /></Tooltip>}
                        </span>,
                        name: seller.name,
                        organizationUnread: this.state.organizationUnread[seller.organization] || 0,
                        notShippedOrder: (this.props.sdsNormalCountWithOrg || {})[seller.organization] || 0,
                        sdsNormal: (this.props.sdsNormalCountWithOrg || {})[seller.organization] || 0,
                        sdsWarning: (this.props.sdsWarningCountWithOrg || {})[seller.organization] || 0,
                        sdsAlert: (this.props.sdsAlertCountWithOrg || {})[seller.organization] || 0,
                        sdsWait: (this.props.sdsWaitingCountWithOrg || {})[seller.organization] || 0
                    });
                });
            }
        }

        if (this.state.organization && this.state.organization.maker) {
            if ((this.props.org && this.props.org.display_name && !this.props.location.pathname.startsWith('/measurement'))) {
                addonBeforeName = '';
            } else {
                addonBeforeName = this.props.location.pathname.startsWith('/measurement') ? '[測定データモード]' : '';
            }
            if (buyersOrganizations) {
                buyersOrganizations.map((buyers, i) => {
                    orgList.push({
                        key: buyers.organization ? `maker_buyer_${buyers.organization}` : `maker_buyer_${i}`,
                        id: buyers.organization,
                        value: `[売先] ${buyers.name}`,
                        label: <span style={{ display: 'flex', gap: 5 }}>
                            {this.state.organizationUnread[buyers.organization] > 0 && <Tooltip title={'未読'}><Badge color={'#52c41a'} title={''} overflowCount={999} count={this.state.organizationUnread[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            [売先] {buyers.name}
                            {(this.props.notShippedOrderWithOrg || {})[buyers.organization] > 0 && <Tooltip title={'未出荷'}><Badge color={'#f5222d'} title={''} overflowCount={999} count={(this.props.notShippedOrderWithOrg || {})[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            {(this.props.cancelOrderWithOrg || {})[buyers.organization] > 0 && <Tooltip title={'キャンセル承認待'}><Badge style={{ borderRadius: 0 }} color={'#ff63e0'} title={''} overflowCount={999} count={(this.props.cancelOrderWithOrg || {})[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            {(this.props.returnOrderWithOrg || {})[buyers.organization] > 0 && <Tooltip title={'返品承認待'}><Badge style={{ borderRadius: 0 }} color={'#00C2FF'} title={''} overflowCount={999} count={(this.props.returnOrderWithOrg || {})[buyers.organization] || 0} showZero={false} /></Tooltip>}
                        </span>,
                        name: buyers.name,
                        organizationUnread: this.state.organizationUnread[buyers.organization] || 0,
                        notShippedOrder: (this.props.sdsNormalCountWithOrg || {})[buyers.organization] || 0,
                        sdsNormal: (this.props.sdsNormalCountWithOrg || {})[buyers.organization] || 0,
                        sdsWarning: (this.props.sdsWarningCountWithOrg || {})[buyers.organization] || 0,
                        sdsAlert: (this.props.sdsAlertCountWithOrg || {})[buyers.organization] || 0,
                        sdsWait: (this.props.sdsWaitingCountWithOrg || {})[buyers.organization] || 0
                    });
                });
            }
        }

        if (this.props.user && this.props.user.admin) {
            if (!this.props.location.pathname.startsWith('/measurement') && this.props.orgSeller && this.props.orgSeller.display_name) {
                addonBeforeName = '';
            } else {
                addonBeforeName = this.props.location.pathname.startsWith('/measurement') ? '[測定データモード]' : '';
            }
            if (sellerOrganizations) {
                sellerOrganizations.map((seller, i) => {
                    orgList.push({
                        key: seller.id ? `admin_seller_${seller.id}` : `admin_seller_${i}`,
                        id: seller.id,
                        value: `[販売側] ${seller.company_name} ${seller.name}`,
                        label: <span style={{ display: 'flex', gap: 5 }}>
                            [販売側] {seller.company_name} {seller.name}
                            {(this.props.sdsNormalCountWithOrg || {})[seller.id] > 0 && <Tooltip title={'正常更新中'}><Badge color={'#4185F4'} title={''} overflowCount={999} count={(this.props.sdsNormalCountWithOrg || {})[seller.id] || 0} showZero={false} /></Tooltip>}
                            {(this.props.cancelOrderWithOrg || {})[seller.id] > 0 && <Tooltip title={'キャンセル承認待'}><Badge style={{ borderRadius: 0 }} color={'#ff63e0'} title={''} overflowCount={999} count={(this.props.cancelOrderWithOrg || {})[seller.id] || 0} showZero={false} /></Tooltip>}
                            {(this.props.returnOrderWithOrg || {})[seller.id] > 0 && <Tooltip title={'返品承認待'}><Badge style={{ borderRadius: 0 }} color={'#00C2FF'} title={''} overflowCount={999} count={(this.props.returnOrderWithOrg || {})[seller.id] || 0} showZero={false} /></Tooltip>}
                        </span>,
                        name: seller.name,
                        name2: `${seller.company_name} ${seller.name}`,
                        organizationUnread: this.state.organizationUnread[seller.organization] || 0,
                        notShippedOrder: (this.props.sdsNormalCountWithOrg || {})[seller.organization] || 0,
                        sdsNormal: (this.props.sdsNormalCountWithOrg || {})[seller.organization] || 0,
                        sdsWarning: (this.props.sdsWarningCountWithOrg || {})[seller.organization] || 0,
                        sdsAlert: (this.props.sdsAlertCountWithOrg || {})[seller.organization] || 0,
                        sdsWait: (this.props.sdsWaitingCountWithOrg || {})[seller.organization] || 0,
                        buyers: seller.buyers
                    });
                });
            }
            if (buyerOrganizations) {
                buyerOrganizations.map((buyers, i) => {
                    orgList2.push({
                        key: buyers.organization ? `admin_buyer_${buyers.organization}` : `admin_buyer_${i}`,
                        id: buyers.organization,
                        value: `[売先] ${buyers.name}`,
                        label: <span style={{ display: 'flex', gap: 5 }}>
                            [売先] {buyers.name}
                            {(this.props.sdsNormalCountWithOrg || {})[buyers.organization] > 0 && <Tooltip title={'正常更新中'}><Badge color={'#4185F4'} title={''} overflowCount={999} count={(this.props.sdsNormalCountWithOrg || {})[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            {(this.props.cancelOrderWithOrg || {})[buyers.organization] > 0 && <Tooltip title={'キャンセル承認待'}><Badge style={{ borderRadius: 0 }} color={'#ff63e0'} title={''} overflowCount={999} count={(this.props.cancelOrderWithOrg || {})[buyers.organization] || 0} showZero={false} /></Tooltip>}
                            {(this.props.returnOrderWithOrg || {})[buyers.organization] > 0 && <Tooltip title={'返品承認待'}><Badge style={{ borderRadius: 0 }} color={'#00C2FF'} title={''} overflowCount={999} count={(this.props.returnOrderWithOrg || {})[buyers.organization] || 0} showZero={false} /></Tooltip>}
                        </span>,
                        name: buyers.name,
                        organizationUnread: this.state.organizationUnread[buyers.organization] || 0,
                        notShippedOrder: (this.props.sdsNormalCountWithOrg || {})[buyers.organization] || 0,
                        sdsNormal: (this.props.sdsNormalCountWithOrg || {})[buyers.organization] || 0,
                        sdsWarning: (this.props.sdsWarningCountWithOrg || {})[buyers.organization] || 0,
                        sdsAlert: (this.props.sdsAlertCountWithOrg || {})[buyers.organization] || 0,
                        sdsWait: (this.props.sdsWaitingCountWithOrg || {})[buyers.organization] || 0
                    });
                });
            }
        }

        if (this.props.user && this.props.user.organizations) {
            this.props.user.organizations.map((buyer, i) => {
                orgListUser.push({
                    key: buyer.organization ? `user_org_${buyer.organization}` : `user_org_${i}`,
                    id: buyer.organization,
                    value: `${buyer.name}`,
                    label: <span style={{ display: 'flex', gap: 5 }}>{buyer.name}</span>
                });
            });
        }

        let selectCountOrgs = this.state.selectCountOrgs;

        const merged = orgList.map(item => {
            const countObj = selectCountOrgs.find(c => c.id === item.id);
            return {
                ...item,
                selectCount: countObj ? countObj.selectCount : 0,
                pinned: countObj ? countObj.pinned : false
            };
        });

        merged.sort((a, b) => {
            if (a.pinned === b.pinned) {
                return b.selectCount - a.selectCount;
            }
            return b.pinned - a.pinned;
        });
        orgList = merged;

        const merged2 = orgList2.map(item => {
            const countObj = selectCountOrgs.find(c => c.id === item.id);
            return {
                ...item,
                selectCount: countObj ? countObj.selectCount : 0
            };
        });

        merged2.sort((a, b) => b.selectCount - a.selectCount);
        orgList2 = merged2;

        const userMenu = {
            items: [
                {
                    label: (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            padding: '10px 0',
                            gap: 5,
                            alignItems: 'center',
                            color: 'rgba(0, 0, 0, 0.85)'
                        }}>
                            <span style={{ fontWeight: 'bold' }}>ユーザー情報</span>
                            <span>{user ? `${user.last_name} ${user.first_name}` : ''}</span>
                            <span>{this.state.company ? this.state.company.name : ''}</span>
                            <span>{this.state.organization ? this.state.organization.name : ''}</span>
                        </div>
                    ),
                    key: '0',
                },
                {
                    label: (<span style={{ display: 'flex', gap: 5 }}><InfoCircleOutlined /> 操作方法</span>),
                    key: '11'
                },
                {
                    label: (<span style={{ display: 'flex', gap: 5 }}><MailOutlined /> 通知メール受信設定</span>),
                    key: '1'
                },
                {
                    type: 'divider',
                },
                {
                    label: 'ログアウト',
                    key: '2',
                }
            ],
            onClick: this.handleMenuClick
        };

        let possibleSelectOrg = this.props.location.pathname !== '/';

        return (
            <>
                <Header
                    style={{
                        padding: '0 10px',
                        background: '#FFFFFF',
                        position: 'sticky',
                        top: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        zIndex: 1,
                        height: 64,
                        boxShadow: '0 1px 4px rgba(0,0,0,0.1)'
                    }}
                >
                    {/* Left side: Hamburger Menu — sidebar-тай адил menu дамжуулна */}
                    <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                        <MobileMenu
                            user={this.props.user}
                            org={this.props.org}
                            userOrg={this.props.userOrg}
                            unreadOrder={this.props.unreadOrder}
                            unreadOrderWithOrg={this.props.unreadOrderWithOrg}
                            unreadBill={this.props.unreadBill}
                            unreadBillWithOrg={this.props.unreadBillWithOrg}
                            unreadDeliveryNotes={this.props.unreadDeliveryNotes}
                            unreadDeliveryNotesWithOrg={this.props.unreadDeliveryNotesWithOrg}
                            unreadEstimates={this.props.unreadEstimates}
                            unreadEstimatesWithOrg={this.props.unreadEstimatesWithOrg}
                            unreadEstimates2={this.props.unreadEstimates2}
                            unreadEstimates2WithOrg={this.props.unreadEstimates2WithOrg}
                            unreadReport={this.props.unreadReport}
                            unreadReportWithOrg={this.props.unreadReportWithOrg}
                            unreadOCH={this.props.unreadOCH}
                            unreadOCHWithOrg={this.props.unreadOCHWithOrg}
                            notShippedOrder={this.props.notShippedOrder}
                            notShippedOrderWithOrg={this.props.notShippedOrderWithOrg}
                            cancelOrder={this.props.cancelOrder}
                            cancelOrderWithOrg={this.props.cancelOrderWithOrg}
                            returnOrder={this.props.returnOrder}
                            returnOrderWithOrg={this.props.returnOrderWithOrg}
                            sdsNormalCount={this.props.sdsNormalCount}
                            sdsNormalCountWithOrg={this.props.sdsNormalCountWithOrg}
                            sdsWarningCount={this.props.sdsWarningCount}
                            sdsWarningCountWithOrg={this.props.sdsWarningCountWithOrg}
                            sdsAlertCount={this.props.sdsAlertCount}
                            sdsAlertCountWithOrg={this.props.sdsAlertCountWithOrg}
                            sdsWaitingCount={this.props.sdsWaitingCount}
                            sdsWaitingCountWithOrg={this.props.sdsWaitingCountWithOrg}
                        />
                    </div>

                    {/* Center side: Org Selectors */}
                    <div style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0 6px',
                        minWidth: 0,
                        flexDirection: 'column',
                        gap: 2
                    }}>
                        {!this.props.user.admin && (
                            <Tooltip title={possibleSelectOrg ? "「詳細画面」では所属事業所、相手先事業所を切り替えることはできません。Home画面に戻って選択し直してください。" : null} placement="top">
                                <Select
                                    style={{ width: '100%' }}
                                    popupClassName="header-org-select-dropdown"
                                    dropdownClassName="header-org-select-dropdown"
                                    listHeight={typeof window !== 'undefined' && window.innerHeight ? Math.floor(window.innerHeight * 0.8) : 500}
                                    placeholder="組織を選択してください"
                                    optionFilterProp="value"
                                    size={"small"}
                                    options={orgListUser}
                                    notFoundContent={'データなし'}
                                    disabled={possibleSelectOrg}
                                    value={this.props.userOrg && this.props.userOrg.display_name}
                                    onSearch={(text) => this.setState({ searchUserOrg: text })}
                                    onSelect={(value, option) => this.selectUserOrg(value, option)}
                                    optionRender={(option) => (
                                        <div className={`${this.props.userOrg && this.props.userOrg.id === option.data.id ? 'ant-select-item-option-selected' : ''}`}
                                            style={{ display: 'flex', flexDirection: 'row', padding: 2, alignItems: 'center', justifyContent: 'space-between' }}>
                                            {option.label}
                                        </div>
                                    )}
                                />
                            </Tooltip>
                        )}
                        {addonBeforeName && <div style={{ fontSize: '12px', alignSelf: 'flex-start', color: '#1890ff', fontWeight: 500, lineHeight: 1 }}>{addonBeforeName}</div>}
                        {
                            !this.props.user.admin ? (
                                <Tooltip title={possibleSelectOrg ? "「詳細画面」では所属事業所、相手先事業所を切り替えることはできません。Home画面に戻って選択し直してください。" : null} placement="top" style={{ width: '100%' }}>
                                    <Select
                                        style={{ width: '100%' }}
                                        popupClassName="header-org-select-dropdown"
                                        dropdownClassName="header-org-select-dropdown"
                                        listHeight={typeof window !== 'undefined' && window.innerHeight ? Math.floor(window.innerHeight * 0.8) : 500}
                                        placeholder="取引先を選択してください"
                                        optionFilterProp="value"
                                        size={"small"}
                                        options={orgList}
                                        notFoundContent={'データなし'}
                                        disabled={possibleSelectOrg}
                                        value={this.props.org && this.props.org.display_name}
                                        onSearch={(text) => this.setState({ searchOrg: text })}
                                        onSelect={(value, option) => this.selectOrg(value, option)}
                                        optionRender={(option) => (
                                            <div className={`${this.props.org && this.props.org.id === option.data.id ? 'ant-select-item-option-selected' : ''}`}
                                                style={{ display: 'flex', flexDirection: 'row', padding: 2, alignItems: 'center', justifyContent: 'space-between', fontSize: '13px', whiteSpace: 'nowrap' }}>
                                                {option.label}
                                                <Button type={"text"} icon={<PushpinOutlined style={{ color: option.data.pinned ? '#1677ff' : '#999' }} rotate={option.data.pinned ? 0 : 90} />}
                                                    onClick={(e) => { e.stopPropagation(); this.pinOrg(option.data.id, option.data.pinned); }} />
                                            </div>
                                        )}
                                    />
                                </Tooltip>
                            ) : (
                                <Select
                                    style={{ width: '100%' }}
                                    popupClassName="header-org-select-dropdown"
                                    dropdownClassName="header-org-select-dropdown"
                                    listHeight={typeof window !== 'undefined' && window.innerHeight ? Math.floor(window.innerHeight * 0.8) : 500}
                                    placeholder={"販売モード側事業所選択"}
                                    optionFilterProp="value"
                                    size={"small"}
                                    options={orgList}
                                    notFoundContent={'データなし'}
                                    value={this.props.orgSeller && this.props.orgSeller.display_name}
                                    onSearch={(text) => this.setState({ searchOrg: text })}
                                    onSelect={(value, option) => this.selectSellerOrganization(option, false)}
                                    optionRender={(option) => (
                                        <div className={`${this.props.orgSeller && this.props.orgSeller.id === option.data.id ? 'ant-select-item-option-selected' : ''}`}
                                            style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>
                                            {option.label}
                                        </div>
                                    )}
                                />
                            )
                        }
                        {
                            this.props.user.admin && !this.props.location.pathname.startsWith('/measurement') && (
                                <Select
                                    showSearch={(this.props.userOrg && this.props.userOrg.buyer) ? false : true}
                                    style={{ width: '100%' }}
                                    popupClassName="header-org-select-dropdown"
                                    dropdownClassName="header-org-select-dropdown"
                                    listHeight={typeof window !== 'undefined' && window.innerHeight ? Math.floor(window.innerHeight * 0.8) : 500}
                                    placeholder="仕入モード側事業所選択"
                                    optionFilterProp="value"
                                    size={"small"}
                                    options={orgList2}
                                    notFoundContent={'データなし'}
                                    value={this.props.org && this.props.org.display_name}
                                    onSearch={(text) => this.setState({ searchOrg: text })}
                                    onSelect={(value, option) => this.selectOrg(value, option)}
                                    showArrow={(this.props.userOrg && this.props.userOrg.buyer) ? false : true}
                                    open={(this.props.userOrg && this.props.userOrg.buyer) ? false : undefined}
                                    optionRender={(option) => (
                                        <div className={`${this.props.org && this.props.org.id === option.data.id ? 'ant-select-item-option-selected' : ''}`}
                                            style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>
                                            {option.label}
                                        </div>
                                    )}
                                />
                            )
                        }
                    </div>

                    {/* Right side: Notification button + User menu */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
                        {this.state.showNotification && this.state.notifications && this.state.notifications.length > 0 && (
                            this.state.notifications.length === 1 ? (
                                <Button
                                    type="primary"
                                    size={"small"}
                                    icon={<BellOutlined />}
                                    onClick={() => this.setState({ selectedNotification: this.state.notifications[0], showNotif: true })}
                                    style={{ fontSize: 11 }}>
                                    {this.state.notifications[0].buttonTitle}
                                </Button>
                            ) : (
                                <Badge count={this.state.notifications.length} size="small" offset={[-2, 2]}>
                                    <Button
                                        type="primary"
                                        size={"small"}
                                        icon={<BellOutlined />}
                                        onClick={() => this.setState({ showListNotif: true })}
                                        style={{ fontSize: 11 }}>
                                        お知らせ
                                    </Button>
                                </Badge>
                            )
                        )}
                        <Dropdown menu={userMenu} trigger={['click']} placement="bottomRight">
                            <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                <UserOutlined style={{ fontSize: '20px' }} />
                            </div>
                        </Dropdown>
                    </div>
                </Header>

                {/* Detail Modal */}
                <Modal
                    title={this.state.selectedNotification?.title}
                    centered
                    open={this.state.showNotif}
                    onCancel={() => {
                        if (this.state.notifications && this.state.notifications.length > 1) {
                            this.setState({ showNotif: false, selectedNotification: null, showListNotif: true });
                        } else {
                            this.setState({ showNotif: false, selectedNotification: null });
                        }
                    }}
                    footer={
                        <Button type="primary" onClick={() => {
                            if (this.state.notifications && this.state.notifications.length > 1) {
                                this.setState({ showNotif: false, selectedNotification: null, showListNotif: true });
                            } else {
                                this.setState({ showNotif: false, selectedNotification: null });
                            }
                        }}>
                            閉じる
                        </Button>
                    }
                >
                    <div style={{ fontSize: 14, lineHeight: 1.6, whiteSpace: "pre-line" }}>
                        {this.state.selectedNotification?.body}
                    </div>
                    {this.state.selectedNotification?.imageUrls && this.state.selectedNotification.imageUrls.length > 0 && (
                        <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 12, borderTop: "1px solid #f0f0f0", paddingTop: 16 }}>
                            <div style={{ fontWeight: "bold", fontSize: 13, marginBottom: 4 }}>添付ファイル:</div>
                            {this.state.selectedNotification.imageUrls.map((url, idx) => {
                                const decodedUrl = decodeURIComponent(url);
                                const isPdf = decodedUrl.toLowerCase().includes(".pdf") || (decodedUrl.includes("alt=media") && decodedUrl.toLowerCase().split("?")[0].endsWith(".pdf"));
                                const parts = decodedUrl.split("/");
                                const rawFileName = parts[parts.length - 1].split("?")[0];
                                const cleanFileName = rawFileName.substring(rawFileName.indexOf("_") + 1);

                                if (isPdf) {
                                    return (
                                        <Button key={idx} type="default" onClick={() => window.open(url, "_blank")} style={{ textAlign: "left", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                            📄 {cleanFileName || `PDFファイル ${idx + 1}`} (PDF) を表示
                                        </Button>
                                    );
                                } else {
                                    return (
                                        <div key={idx} style={{ textAlign: "center", marginBottom: 8 }}>
                                            <div style={{ fontSize: 12, color: "#888", textAlign: "left", marginBottom: 4 }}>🖼️ {cleanFileName || `画像 ${idx + 1}`}</div>
                                            <Image
                                                src={url}
                                                alt={`attachment-${idx}`}
                                                style={{ maxWidth: "100%", maxHeight: 300, borderRadius: 4, border: "1px solid #f0f0f0", objectFit: "contain" }}
                                                placeholder={
                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 150, background: "#fafafa", borderRadius: 4 }}>
                                                        <Spin />
                                                    </div>
                                                }
                                            />
                                        </div>
                                    );
                                }
                            })}
                        </div>
                    )}
                </Modal>

                {/* List Modal */}
                <Modal
                    title="お知らせ一覧"
                    centered
                    open={this.state.showListNotif}
                    onCancel={() => this.setState({ showListNotif: false })}
                    footer={
                        <Button onClick={() => this.setState({ showListNotif: false })}>
                            閉じる
                        </Button>
                    }
                >
                    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                        {this.state.notifications && this.state.notifications.map((notif, index) => (
                            <div 
                                key={notif.id || index}
                                style={{
                                    padding: "12px 16px",
                                    border: "1px solid #f0f0f0",
                                    borderRadius: 8,
                                    cursor: "pointer",
                                    transition: "background 0.3s",
                                }}
                                onClick={() => {
                                    this.setState({
                                        selectedNotification: notif,
                                        showNotif: true,
                                        showListNotif: false
                                    });
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.background = "#fafafa"}
                                onMouseLeave={(e) => e.currentTarget.style.background = "#fff"}
                            >
                                <div style={{ fontWeight: "bold", fontSize: 15, color: "#1677ff", marginBottom: 4 }}>
                                    {notif.title}
                                </div>
                                <div style={{ fontSize: 13, color: "#666", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>
                                    {notif.body}
                                </div>
                            </div>
                        ))}
                    </div>
                </Modal>
            </>
        );
    }
}

export default withRouter(MobileNavbar);
